const configPage =
    {
        i18n: true,
        editor: {
            preview: false
        }
    }


export default configPage;
